import style from "./About1.module.css";
import Partnership from "../IndexPage/Partnership.js";
import aboutjm from "../../assets/images/aboutjm.png";
import aboutjmimg from "../../assets/images/aboutjmimg.png";
import about1title2 from "../../assets/images/about1title2.png";

import about1s2i1 from "../../assets/images/about1-s2-i1.png";
import about1s2i2 from "../../assets/images/about1-s2-i2.png";

import abouticon1 from "../../assets/images/abouticon/1.png";
import abouticon2 from "../../assets/images/abouticon/2.png";
import abouticon3 from "../../assets/images/abouticon/3.png";
import abouticon4 from "../../assets/images/abouticon/4.png";
import abouticon5 from "../../assets/images/abouticon/5.png";
import abouticon6 from "../../assets/images/abouticon/6.png";
import abouticon1a from "../../assets/images/abouticon/a1.png";
import abouticon2a from "../../assets/images/abouticon/a2.png";
import abouticon3a from "../../assets/images/abouticon/a3.png";
import abouticon4a from "../../assets/images/abouticon/a4.png";
import abouticon5a from "../../assets/images/abouticon/a5.png";
import abouticon6a from "../../assets/images/abouticon/a6.png";

import { useState, useEffect } from "react";
import request from "../../common/request";

export default function Main() {
  const [data, setData] = useState({});
  useEffect(() => {
    request.getColumnList("公司简介").then((result) => {
      console.log(result.data);
      if (result.data.data.data && result.data.data.data.length > 0) {
        var data = result.data.data.data[0];
        setData(data);
      }
      console.log("list", data);
    });
  }, []);

  return (
    <>
      <div className={style.section1}>
        <img src={aboutjmimg} className={style.aboutjmimg} />

        <img src={aboutjm} className={style.aboutjm} />
        <p>{data.content}</p>
      </div>
      <div className="clear"></div>
      <div className={style.section2}>
        <img src={about1title2} />
        <div className={style.section2c}>
          <div className={style.sleft}>
            <div className={style.list}>
              <div>
                <img src={abouticon1} className={style.normal} />
                <img src={abouticon1a} className={style.active} />
                <h3>经营理念</h3>
                <p>合规经营,诚实笃信, 敬业奉献,稳健发展。</p>
              </div>
              <div>
                <img src={abouticon2} className={style.normal} />
                <img src={abouticon2a} className={style.active} />
                <h3>品牌价值</h3>
                <p>资本充足,内控严密, 营运规范,服务优良, 安全高效。</p>
              </div>
              <div>
                <img src={abouticon3} className={style.normal} />
                <img src={abouticon3a} className={style.active} />
                <h3>经营宗旨</h3>
                <p>解企业发展之困, 促多方合作共赢。</p>
              </div>
            </div>
            <img src={about1s2i1} />
          </div>
          <div className={style.sright}>
            <img src={about1s2i2} />
            <div className={style.list}>
              <div>
                <img src={abouticon4} className={style.normal} />
                <img src={abouticon4a} className={style.active} />
                <h3>企业精神</h3>
                <p>坚守正道,虔诚勤勉, 严谨高效,追求卓越。</p>
              </div>
              <div>
                <img src={abouticon5} className={style.normal} />
                <img src={abouticon5a} className={style.active} />
                <h3>核心价值观</h3>
                <p>中小微企业融资担保专家。</p>
              </div>
              <div>
                <img src={abouticon6} className={style.normal} />
                <img src={abouticon6a} className={style.active} />
                <h3>企业愿景</h3>
                <p>致力打造浙南闽北融资 担保第一品牌。</p>
              </div>
            </div>
          </div>
        </div>
        <div className="clear"></div>
      </div>
      <Partnership />
    </>
  );
}
